import { AngularFirestore } from '@angular/fire/firestore';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {
  tickets: any;
  constructor( private afs: AngularFirestore) { }
  async ngOnInit() {
    const tickets = await this.afs.collection('tickets', res => {
      return res.orderBy('createdAt', 'desc');
    }).valueChanges();
    this.tickets = tickets;
    console.log(this.tickets);
  }

}



// WEBPACK FOOTER //
// ./src/app/Ticket/tickets/tickets.component.ts